/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.14.1
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { TWizardBillsDocSetParamsPayload } from './types/wizardBillsDocActionTypes';
import { initialWizardBillsDocState, IWizardBillsDocReducer } from './wizardBillsDocReducer';

export const makeSelectWizardBillsDocState = (state: IRootReducer): IWizardBillsDocReducer =>
    state.wizardBillsDoc || initialWizardBillsDocState;

export const makeSelectWizardBillsDocParam = (key: keyof TWizardBillsDocSetParamsPayload):
    OutputSelector<IRootReducer, any, (state: IWizardBillsDocReducer) => any> =>
    createSelector(makeSelectWizardBillsDocState, state => state[key]);

export const makeSelectWizardBillsDocIsStepValid = ():
    OutputSelector<IRootReducer, boolean, (state: IWizardBillsDocReducer) => boolean> =>
    createSelector(makeSelectWizardBillsDocState, state => state.isStepValid);
